import { Page } from '@/core/architecture'

import { TicketOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ticketHistory Page
 * Implemented as a practical sample.
 */
export const TicketOrders: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <TicketOrdersTemplate state={state} onFetchMore={actions.onFetchMore} />
  )
}
